import { ArrowUpRight, Youtube } from "lucide-react";
import SectionHeading, { Reveal } from "./SectionHeading";

export default function HowIDoIt({ videos, channelUrl, appleMusicUrl }) {
  const musicEmbedUrl = appleMusicUrl.replace(
    "music.apple.com",
    "embed.music.apple.com"
  );
  return (
    <section
      id="how-i-do-it"
      data-testid="section-how-i-do-it"
      className="mx-auto max-w-7xl px-6 py-24 md:py-36"
    >
      <SectionHeading
        number="05"
        title="HOW I DO IT"
        sub="Off the field"
        id="how-i-do-it"
      />

      <div className="grid gap-6 lg:grid-cols-2">
        <div className="flex flex-col gap-6">
          <Reveal>
            <a
              data-testid="youtube-channel-link"
              href={channelUrl}
              target="_blank"
              rel="noreferrer"
              className="group flex items-center justify-between gap-6 rounded-2xl border border-white/10 bg-panel p-7 transition-colors duration-300 hover:border-hotpink"
            >
              <div>
                <p className="flex items-center gap-2 font-jbmono text-[10px] uppercase tracking-[0.3em] text-hotpink">
                  <Youtube className="h-4 w-4" />
                  My Channel
                </p>
                <p className="mt-3 font-bebas text-4xl leading-none tracking-wide">
                  YOUTUBE / @ALTX22
                </p>
                <p className="mt-2 text-sm text-white/50">
                  Anime & car edits — every cut made by Big Cal himself
                </p>
              </div>
              <ArrowUpRight className="h-9 w-9 shrink-0 text-white/30 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-hotpink" />
            </a>
          </Reveal>

          <div className="grid gap-6 sm:grid-cols-2">
            {videos.map((v, i) => (
              <Reveal key={i} delay={0.08 * (i + 1)}>
                <div
                  data-testid={`how-video-${i + 1}`}
                  className="overflow-hidden rounded-2xl border border-white/10 bg-panel transition-colors duration-300 hover:border-neon"
                >
                  <div className="aspect-video overflow-hidden bg-black">
                    <iframe
                      className="h-full w-full"
                      src={`https://www.youtube-nocookie.com/embed/${v.youtubeId}`}
                      title={v.title}
                      loading="lazy"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                  <p className="px-5 py-4 font-bebas text-xl tracking-wide">
                    {v.title}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.1}>
          <div
            data-testid="music-playlist"
            className="flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-panel transition-colors duration-300 hover:border-neon"
          >
            <div className="flex items-center justify-between border-b border-white/10 px-7 py-4">
              <p className="font-jbmono text-[10px] uppercase tracking-[0.3em] text-neon">
                The Playlist — Aura Sauce
              </p>
              <span className="hidden font-jbmono text-[10px] tracking-[0.3em] text-white/30 sm:block">
                PLAY · PAUSE · VOLUME BUILT IN
              </span>
            </div>
            <div className="flex-1 p-4">
              <iframe
                data-testid="music-embed"
                title="Aura Sauce playlist"
                src={musicEmbedUrl}
                className="h-full min-h-[420px] w-full rounded-xl"
                frameBorder="0"
                loading="lazy"
                allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write"
                sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation-by-user-activation"
              />
            </div>
            <a
              data-testid="music-open-link"
              href={appleMusicUrl}
              target="_blank"
              rel="noreferrer"
              className="group flex items-center justify-between border-t border-white/10 px-7 py-4 transition-colors duration-300 hover:bg-white/[0.03]"
            >
              <span className="font-jbmono text-[10px] tracking-[0.3em] text-white/50 transition-colors group-hover:text-neon">
                OPEN IN APPLE MUSIC
              </span>
              <ArrowUpRight className="h-4 w-4 text-white/30 transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-neon" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
